// extracted by css-extract-rspack-plugin
export default {"banner":"banner-adTcIu","text":"text-X5sQ_k"};